module.exports = __webpack_public_path__ + "static/media/dj.3cf620d9.svg";